import { scroller } from 'react-scroll'

export const smoothScrollTo = (elementId: string) => {
  scroller.scrollTo(elementId, {
    duration: 400,
    delay: 0,
    smooth: 'easeInOutQuart',
    offset: -100,
  })
}
